import React from 'react';

import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

const LazyWidgetsTranslationDialog = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widgets-translation-dialog' */
            './WidgetsTranslationDialog'
        ),
);

export function WidgetsTranslationDialog(props: React.ComponentProps<typeof LazyWidgetsTranslationDialog>) {
    const { isOpen } = props;
    return (
        <DelayedSuspense shouldLoad={isOpen} isDialog>
            <LazyWidgetsTranslationDialog {...props} />
        </DelayedSuspense>
    );
}
